import React from 'react';
import {useStyles} from './TakisMediaComponent.styles';
import PropTypes from 'prop-types';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import TakisBoxWithImage from './TakisBoxWithImage';

function TakisMediaComponent({description, alignImage, imageSrc, imageMobileSrc, imageAlt, caption}) {
    const classes = useStyles();

    TakisMediaComponent.propTypes = {
      description: PropTypes.string,
      imageSrc: PropTypes.string.isRequired,
      imageMobileSrc: PropTypes.string.isRequired,
      imageAlt: PropTypes.string.isRequired,
      alignImage: PropTypes.string,
      caption: PropTypes.string
    };

    return (
      <Card className={classes.card}>
        <CardContent
          className={`${classes.cardContent}
          ${alignImage === "left" ? classes.imageLeft : alignImage === "full" ? classes.imageCenter : ""}`}
          >
          {
            alignImage !== "full" &&
            <div
              className={classes.description}
              dangerouslySetInnerHTML={{__html: description}}
            />
          }
          <TakisBoxWithImage
            imageSrc={imageSrc}
            imageMobileSrc={imageMobileSrc}
            imageAlt={imageAlt}
            caption={caption}
          />
        </CardContent>
      </Card>
  );
}

export default TakisMediaComponent;
